<div>

  <div style="margin-top: 10px; margin-left: 6px;">
    <div class="row" style="border-bottom: 1px solid rgb(241, 240, 240);" *ngIf="patientDetails">
      <div class="col-md-3" *ngIf="!patientDetails.profileUrl">
        <img src="../../assets/user_profile_default.png" class="profileImg">
      </div>
      <div class="col-md-3" *ngIf="patientDetails.profileUrl">
        <img src="{{patientDetails.profileUrl}}" class="profileImg">
      </div>
      <div class="col-md-7 county-ans-class">
        <div class="row">
          <div class="col-md-3 county-pc-class">
            <span style="font-size: 12px;" *ngIf="patientDetails.county">{{'County' | translateOrgSpecific}}</span><br>
            <span style="color: var(--background-primary)"><b>{{patientDetails.county}}</b></span>

          </div>
          <div class="col-md-9">
            <div class="county-ipad-class">
              <span style="font-size: 12px;" *ngIf="patientDetails.county">{{'County' |
                translateOrgSpecific}}</span><br>
              <span style="color: var(--background-primary)"><b>{{patientDetails.county}}</b></span>

            </div>
            <div class="default-case-question" *ngFor="let data of patientDetails.questionAndAnswer; index as i">
              <span style="font-size: 12px;">{{data.questiontext}}</span><br>
              <div style="padding-left: 2px;">

                <ng-template #CategorytoolTip>
                  <div> {{data.joinedAnswer}}
                  </div>
                </ng-template>
                <div [ngbTooltip]="CategorytoolTip" class="wrap-text answer" *ngIf="data.joinedAnswer.length>15"
                  placement="bottom">
                  {{data.joinedAnswer}}
                </div>
                <div class="wrap-text answer" *ngIf="16>data.joinedAnswer.length">
                  {{data.joinedAnswer}}
                </div>


              </div>
            </div>
          </div>

        </div>

        <div class="row email-ph-pc" style="margin-top:8%;">
          <div class="col-xs-3 col-sm-3 col-lg-3">
            <span style="font-size: 12px;">{{'PhoneNumber' | translateOrgSpecific}}</span> <br>
            <span><span *ngIf="patientDetails.countryCodeValue">{{patientDetails.countryCodeValue}} </span>{{patientDetails.phoneNumber | tel}}</span>
          </div>
          <div class="col-xs-3 col-sm-3 col-lg-3 ">
            <span style="font-size: 12px;">{{'Email' | translateOrgSpecific}}</span> <br>
            <span>{{patientDetails.email}}</span>
          </div>
        </div>

        <div class="row email-ph-ipad">
          <div class="col-md-12">
            <span style="font-size: 12px;">{{'PhoneNumber' | translateOrgSpecific}}</span> <br>
            <span><span *ngIf="patientDetails.countryCodeValue">{{patientDetails.countryCodeValue}} </span>{{patientDetails.phoneNumber | tel}}</span>
          </div>
          <div class="col-md-12">
            <span style="font-size: 12px;">{{'Email' | translateOrgSpecific}}</span> <br>
            <span>{{patientDetails.email}}</span>
          </div>
        </div>



      </div>
      <div class="col-md-2" style="padding-right: 0px !important; padding-left: 0px !important; cursor: pointer;">
        <div style="padding-bottom: 5px;">
          <a href="/clinicianvideo/editparticipantprofile/{{patientId}}/basicInfo" title="Basic Info" target="_blank">

            <span class="grid-icon"><i class="far fa-address-card mr-2 fosz" aria-hidden="true"></i></span>

            <label style="font-size: 10px !important; cursor: pointer; " class="icon-label">
              {{'BasicInfo' | translateOrgSpecific}}
            </label>
          </a>
        </div>
        <div style="padding-bottom: 5px;">
          <a href="/clinicianvideo/editparticipantprofile/{{patientId}}/generalQuestion" title="General Questions"
            target="_blank">

            <span class="grid-icon"> <i class="fas fa-qrcode mr-2   fosz" aria-hidden="true"></i></span>
            <label style="font-size: 10px !important; cursor: pointer; " class="icon-label">
              {{'GeneralQuestion' | translateOrgSpecific}}
            </label>

          </a>
        </div>
        <div style="padding-bottom: 5px;">
          <a href="/clinicianvideo/editparticipantprofile/{{patientId}}/Docs" title="Documents" target="_blank">

            <span class="grid-icon"><i class="fas fa-file mr-2 fosz" aria-hidden="true"></i></span>
            <label style="font-size: 10px !important; cursor: pointer;" class="icon-label">
              {{'Documents' | translateOrgSpecific}} </label>
          </a>
        </div>




      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 10px; " *ngIf="caseDetailsList">
    <div class="col-xs-6 col-sm-6 col-lg-4" style="border-right: 1px solid rgb(241, 240, 240);">
      <div style="margin-bottom: 10px;">
        <label class="caselistHead">Cases</label>
        <button class="btn btn-apportis-primary-theme" (click)="openCase()" style="float: right;">{{ 'AddCase' |
          translateOrgSpecific }}</button>
      </div>


      <div class="caseDisp" *ngFor="let list of caseDetailsList; index as i" (click)="onClick(i,list)"
        [ngClass]="{'highlight': selectedIndex === i}">
        <div style="width: 90%; font-size: 13px !important;"><span>{{list.issueCategoryName}}</span></div>
        <span style="font-size: 12px !important;">{{'RegisteredBy' | translateOrgSpecific}}
          {{list.createUserName}}</span>
        <span style="float: right;font-size: 13px !important" [ngClass]="list.caseStatus">{{list.caseStatus}}</span><br>
        <span style="font-size: 12px !important;">{{'on' | translateOrgSpecific}}
          {{list.create_ts | date:'MMMM dd, yyyy hh:mm a'}}</span>
        <!-- <hr> -->
      </div>


    </div>
    <div class="col-xs-6 col-sm-6 col-lg-8">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link heading active" id="test-tab" data-toggle="tab" href="#test" role="tab"
            aria-controls="test" aria-selected="false">{{'CaseDetails' | translateOrgSpecific}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link  heading" id="notes-tab" data-toggle="tab" href="#note" role="tab" aria-controls="note"
            aria-selected="true">{{'Notes' | translateOrgSpecific}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link heading" id="assistance-tab" data-toggle="tab" href="#assistance" role="tab"
            aria-controls="assistance" aria-selected="false">{{'Assistance' | translateOrgSpecific}}</a>
        </li>



      </ul>
      <div class="tab-content" id="myTabContent" style="font-size: 13px !important;">


        <div class="tab-pane fade show active" id="test" role="tabpanel" aria-labelledby="test-tab">
          <div class="row" style="margin-top:10px">


            <div class="col-md-12">
              <div class="caseHeading"><label>{{caseName}}</label></div>
              <div class="btnAlign">

                <button class="btn btn-apportis-primary-theme padding-btn-ipad " style="margin-left: 5px; width: 60px;"
                  (click)="closeCase()" [disabled]="isButtonDisabled || caseId == 0">{{'Close' |
                  translateOrgSpecific}}</button>
                <button class="btn btn-apportis-primary-theme " style="margin-left: 5px; width: 60px;"
                  (click)="EditCase(caseCode)"
                  [disabled]="isButtonDisabled || caseId == 0 || caseDetails.length == 0">{{'Edit' |
                  translateOrgSpecific}}</button>
              </div>
            </div>

          </div>

          <div class="row" style="margin-top: 10px;">
            <div class="col-md-6">
              <div *ngFor="let data of caseDetails; index as i">
                <div *ngIf="i%2==0" style="margin-bottom: 10px;">
                  <span style="font-size: 13px;">{{data.questiontext}}</span><br>
                  <div *ngFor="let obj of data.answerList">
                    {{obj}}

                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let data of caseDetails; index as i">
                <div *ngIf="i%2!=0" style="margin-bottom: 10px;">
                  <span style="font-size: 13px;">{{data.questiontext}}</span><br>

                  <div *ngFor="let obj of data.answerList">
                    {{obj}}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="tab-pane fade " id="note" role="tabpanel" aria-labelledby="notes-tab" style="font-size: 13px;">
          <div class="addNotesBtn">
            <button class="btn btn-apportis-primary-theme" (click)="addNotes()"
              [disabled]="isButtonDisabled || caseId == 0">{{'AddNotes' | translateOrgSpecific}}</button>
          </div>
          <div *ngIf="caseNotes.length == 0">
            {{'NoNotesAvailable' | translateOrgSpecific}}
          </div>
          <div *ngFor="let data of caseNotes; index as i" style="margin-top: 5px;">
            <label *ngIf="data.isAppoinment">{{'AppointmentCompletedOn' | translateOrgSpecific}}
              {{data.noteDate | date:'MMMM dd, yyyy hh:mm a'}}</label>
            <label *ngIf="!data.isAppoinment && !data.caseactionId">{{'CaseNoteOn' | translateOrgSpecific}}
              {{data.noteDate | date:'MMMM dd, yyyy hh:mm a'}}</label>
            <label *ngIf="data.caseactionId > 0">{{'AssistanceNoteOn' | translateOrgSpecific}}
              {{data.noteDate | date:'MMMM dd, yyyy hh:mm a'}}</label>
            <div>
              <label> {{'CreateBy' | translateOrgSpecific}}: {{data.firstName}} {{data.lastName}}</label>
            </div>

            <div>
              <label>{{'Notes' | translateOrgSpecific}} : {{data.notes}}</label>
            </div>
          </div>

        </div>

        <div class="tab-pane fade" id="assistance" role="tabpanel" aria-labelledby="assistance-tab"
          style="font-size: 13px !important;">
          <div class="addNotesBtn">
            <button class="btn btn-apportis-primary-theme " style="margin-left: 5px;" (click)="addAction()"
              [disabled]="isButtonDisabled || caseId == 0">{{'Assistance' | translateOrgSpecific}}</button>
          </div>

          <div *ngIf="assistanceHistory.length == 0">
            {{'NoAssistance' | translateOrgSpecific}}
          </div>
          <div *ngFor="let data of assistanceHistory; index as i" style="margin-top: 15px;">
            <div class="row">
              <div class="col-md-4">
                <label>{{'AssistanceNoteOn' | translateOrgSpecific}}</label>
              </div>
              <div class="col-md-8">
                <label>: {{data.createTs | date:'MMMM dd, yyyy hh:mm a'}}</label>
              </div>

            </div>
            <div class="row">
              <div class="col-md-4">
                <label>{{'AssistanceAddedBy' | translateOrgSpecific}}</label>
              </div>
              <div class="col-md-8">
                <label>: {{data.username}}</label>
              </div>

            </div>
            <div class="row">
              <div class="col-md-4">
                <label>{{'Category' | translateOrgSpecific}}</label>
              </div>
              <div class="col-md-8">
                <label>: {{data.actionTypeName}}</label>
              </div>

            </div>
            <div class="row" *ngIf="data.actionName">
              <div class="col-md-4">
                <label>{{'Assistance' | translateOrgSpecific}}</label>
              </div>
              <div class="col-md-8">
                <label>: {{data.actionName}}</label>
                <div><label *ngIf="data.remarks" style="padding-left: 5px;"> {{data.remarks}}</label></div>

              </div>

            </div>
            <div class="row" *ngIf="data.agencyname">
              <div class="col-md-4">

              </div>
              <div class="col-md-8">
                <label style="padding-left: 5px;">{{data.agencyname}}</label>
              </div>

            </div>
            <div class="row" *ngIf="data.notes">
              <div class="col-md-4">
                <label>Note</label>
              </div>
              <div class="col-md-8">
                <label style="padding-left: 5px;">{{data.notes}}</label>
              </div>

            </div>

          </div>

        </div>
        <!-- //Document Tab -->
        <!-- <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
          <div *ngIf="userDoclist.length == 0" class="NodocumentsDiv" >
            {{'Nodocuments' | translateOrgSpecific}}
          </div>
          <div class="table-responsive" style="padding:15px;" *ngIf="userDoclist.length>0">
            <table class="table table-striped table-sm ">
              <thead>
                <tr>
                  <th scope="col" class="col1">{{ 'Title' | translateOrgSpecific }}</th>
                  <th scope="col" class="col2">{{ 'Description' | translateOrgSpecific }}</th>
                  <th scope="col" class="col3">{{ 'Category' | translateOrgSpecific }}</th>
                  <th scope="col" class="col6">{{'Action' | translateOrgSpecific }}</th>
                </tr>
              </thead>
              <tbody>
               
                <tr *ngFor="let element of userDoclist; let i = index">
                  <td class="col1"> {{element.documentTitle}} </td>
                  <td class=" col2"> {{element.description}}</td>
                  <td class=" col3"> {{element.category}}</td>
  
  
  
                  <td style="min-width: 15%; " class="col6">
                    <a title="View" class="grid-link " target="_blank" routerLink="/docview/{{element.docUrl}}/clientDoc"
                      style="padding-right: 10px;">
                      <span class="grid-icon"><i class="far fa-eye " aria-hidden="true"></i></span>
  
                    </a>
  
  
                    <a title="Delete" class="grid-link" style="padding-left: 8px;">
                      <span class="grid-icon"><i class="fas fa-trash" aria-hidden="true"
                          (click)="confirmDelete(element)"></i></span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
  
          <div class="info-popup" style="width:315px;" *ngIf="deleteConfirm">
            <div style="margin:12px;">
              <div style="margin-left:10px;">
                <div>{{ 'DeleteLibraryDocMessage' | translateOrgSpecific }}</div>
              </div>
              <div style="margin-top: 10px;margin-left: 10px;">
                <button style="width:100px;display: inline-block;margin-top:0px;"
                  class="btn btn-apportis-primary-theme btn-block"
                  (click)="delete()">{{ 'Confirm' | translateOrgSpecific }}</button>
                <button style="width:100px;display: inline-block;margin-top:0px;margin-left:10px"
                  class="btn btn-apportis-primary-theme btn-block" appTeme
                  (click)="cancelDelete()">{{ 'Cancel' | translateOrgSpecific }}</button>
              </div>
            </div>
          </div>
        </div> -->


        <!-- //Document tab end -->

      </div>
    </div>
  </div>

  <div class="info-popup" style="width:315px;" *ngIf="closeConfirm">
    <div style="margin:12px;">
      <div style="margin-left:10px;">
        <div>{{'CloseCaseConfirmMsg' | translateOrgSpecific}}</div>
      </div>
      <div style="margin-top: 10px;margin-left: 10px;">
        <button style="width:100px;display: inline-block;margin-top:0px;"
          class="btn btn-apportis-primary-theme btn-block" (click)="close()">{{'Confirm' |
          translateOrgSpecific}}</button>
        <button style="width:100px;display: inline-block;margin-top:0px;margin-left:10px"
          class="btn btn-apportis-primary-theme btn-block" appTeme (click)="cancelClose()">{{'Cancel' |
          translateOrgSpecific}}</button>
      </div>
    </div>
  </div>